module.exports = __webpack_public_path__ + "static/media/fresh.5da66165.svg";